import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-confirm',
    templateUrl: './dialog-confirm.component.html',
    styleUrls: ['./dialog-confirm.component.scss'],
    standalone: false
})
export class DialogConfirmComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogConfirmComponentData,
  ) {}

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close(false);
  }

  handleConfirm() {
    this.dialogRef.close(true);
  }
}

export interface DialogConfirmComponentData {
  title: string;
  descriptionHtml: string;
  addDescriptionHtml?: string;
  confirmBtn: string;
  cancelBtn?: string;
  closeIconPath?: string;
}
